import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { setToken, setUser, clearAuth, isAuthenticated } from '../utils/auth';
import { authService } from '../services/api';
import './Login.css';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Llamada real a la API
      const response = await authService.login(formData.email, formData.password);
      
      if (response.success && response.token) {
        // Guardar token
        setToken(response.token);
        
        // Crear objeto usuario básico con la información disponible
        const user = {
          id: response.id || 'unknown',
          email: formData.email,
          // El backend no devuelve nombre ni rol, así que usamos valores por defecto
          name: response.name || 'Usuario',
          role: response.role || 'user'
        };
        
        setUser(user);
        
        // Redirigir al dashboard
        navigate('/admin');
      } else {
        setError('Credenciales inválidas');
      }
      
    } catch (error) {
      setError(error.message || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    clearAuth();
    window.location.reload();
  };

  // Si ya está autenticado, mostrar opción de logout
  if (isAuthenticated()) {
    return (
      <div className="login-container">
        <div className="login-card">
          <h2>Ya estás autenticado</h2>
          <p>Parece que ya tienes una sesión activa.</p>
          <div className="authenticated-buttons">
            <button 
              onClick={() => navigate('/administrador')} 
              className="login-button"
            >
              Ir al Administrador
            </button>
            <button 
              onClick={handleLogout} 
              className="logout-button"
            >
              Cerrar Sesión
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <h2>Iniciar Sesión</h2>
        
        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="Ingresa tu email"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Contraseña:</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder="Ingresa tu contraseña"
            />
          </div>

          <button 
            type="submit" 
            className="login-button"
            disabled={loading}
          >
            {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
          </button>
        </form>

        <div className="login-footer">
          <p>Contacta al administrador para crear una cuenta</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
